var render = function render(){var _vm=this,_c=_vm._self._c;return _c('JTPDropdown',{staticClass:"p-paginator-page-options",attrs:{"value":_vm.page,"options":_vm.pageOptions,"optionLabel":"label","optionValue":"value","disabled":_vm.disabled},on:{"input":function($event){return _vm.onChange($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }